import { defineStore } from 'pinia';
import axios from 'axios';
import { useAuthStore } from './auth';

const STRAPI_URL = import.meta.env.VITE_STRAPI_URL ?? 'http://localhost:1337';

const normalizeJournal = (entry) => {
	const attributes = entry?.attributes || entry || {};
	return {
		id: entry?.id ?? attributes.id ?? null,
		name: attributes.name ?? entry?.name ?? 'Untitled journal',
	};
};

export const useJournalStore = defineStore('journal', {
	state: () => ({
		journals: [],
		loading: false,
		error: null,
		initialized: false,
		activeJournalId: null,
	}),
	getters: {
		journalList: (state) => state.journals,
		activeJournal: (state) =>
			state.journals.find((journal) => journal.id === state.activeJournalId) || null,
	},
	actions: {
		authHeaders() {
			const authStore = useAuthStore();
			return authStore.token ? authStore.requestHeaders.headers : {};
		},

		async initialize() {
			if (this.initialized || this.loading) {
				return;
			}
			await this.fetchJournals();
			this.initialized = true;
		},

		async fetchJournals() {
			this.loading = true;
			this.error = null;
			try {
				const response = await axios.get(`${STRAPI_URL}/api/journals`, {
					headers: this.authHeaders(),
				});
				const entries = response?.data?.data || [];
				const normalized = entries.map(normalizeJournal);

				const ensureVirtualJournal = (name, id) => {
					const exists = normalized.some(
						(journal) => (journal.name || '').toLowerCase() === name.toLowerCase(),
					);
					if (!exists) {
						normalized.push({
							id,
							name,
							isVirtual: true,
						});
					}
				};

				ensureVirtualJournal('Purchases', 'virtual-purchases');

				this.journals = normalized;
				if (!this.activeJournalId && this.journals.length > 0) {
					this.activeJournalId = this.journals[0].id;
				}
			} catch (error) {
				this.error = error?.response?.data?.error?.message || error.message || 'Failed to load journals';
				throw error;
			} finally {
				this.loading = false;
			}
		},

		setActiveJournal(journalId) {
			this.activeJournalId = journalId;
		},
	},
});
